import { Fragment } from 'react';
import '../css/styles.css';
import { Dialog, Transition } from '@headlessui/react'
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const DeleteModal = props => {
    const handleDelete = async() => {
        if(props.action === 'arrival'){
            const docRef = doc(db, "takenSeatsIN", "0sdzi0dXHrNHAQona5wc");
            const docRef2 = doc(db, "arrivalHistory", "XgVI85U7pm6vLohGrFAU");
            const response = await getDoc(docRef);
            const response2 = await getDoc(docRef2);

            if (response.exists() && response2.exists()) {
                const takenSeatsIN = response.data().takenSeatsIN;
                const arrivalHistory = response2.data().arrivalHistory;
                const deleteIndex = takenSeatsIN.findIndex((seat) => seat.uid === props.uid);
                const deleteIndex2 = arrivalHistory.findIndex((seat) => seat.uid === props.uid);
                if(deleteIndex > -1){
                    takenSeatsIN.splice(deleteIndex, 1);
                }

                if(deleteIndex2 > -1){
                    arrivalHistory.splice(deleteIndex2, 1);
                }

                setDoc(docRef, {
                    takenSeatsIN: takenSeatsIN
                }).then(() => {
                    setDoc(docRef2, {
                        arrivalHistory: arrivalHistory
                    }).then(() => window.location.reload())
                })
            }
        }else if(props.action === 'departure'){
            const docRef= doc(db, 'takenSeatsOUT', '5aadATVLnDArSFAEi2CA');
            const docRef2 = doc(db, "departuresHistory", "8N1Nm7FoKCdHgiai3rEM");
            const response = await getDoc(docRef);
            const response2 = await getDoc(docRef2);

            if (response.exists() && response2.exists()) {
                const takenSeatsOUT = response.data().takenSeatsOUT;
                const departuresHistory = response2.data().departuresHistory;
                const deleteIndex = takenSeatsOUT.findIndex((seat) => seat.uid === props.uid);
                const deleteIndex2 = departuresHistory.findIndex((seat) => seat.uid === props.uid);
                if(deleteIndex > -1){
                    takenSeatsOUT.splice(deleteIndex, 1);
                }

                if(deleteIndex2 > -1){
                    departuresHistory.splice(deleteIndex2, 1);
                }

                setDoc(docRef, {
                    takenSeatsOUT: takenSeatsOUT
                }).then(() => {
                    setDoc(docRef2, {
                        departuresHistory: departuresHistory
                    }).then(() => window.location.reload())
                })
            }
        }
    }

    return (
        <Transition.Root show={props.open}>
            <Dialog as="div" className="absolute" style={{ zIndex: '20' }} initialFocus={props.cancelButtonRef} onClose={() => {}}>
                <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 w-screen overflow-y-auto" style={{ zIndex: '20' }}>
                <div className="flex min-h-full items-end justify-center align-center p-4 text-center sm:items-center sm:p-0">
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                    <Dialog.Panel style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', height: '300px' }} className="relative width transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xs">
                        <div style={{ width: '100%', height: '70%' }} className="bg-white">
                        <div style={{ width: '100%' }} className="sm:flex sm:flex-col sm:items-center">
                            <div style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', width: '100%' }} className="text-center mt-3">
                            <Dialog.Title as="h3" className="text-sm font-semibold leading-6 text-gray-900">
                                Are you sure you want to cancel the {props.action}?
                            </Dialog.Title>
                            <div style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: '1rem' }}>
                                {props.action === 'arrival' ? <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Parking place: </strong>{props.placeIdInfo}
                                </p> : ""} 
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Date: </strong>{props.dateInfo}
                                </p>   
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                    <strong>Registeration number: </strong>{props.registrationNumberInfo}
                                </p>  
                                <p style={{ textAlign: 'center' }} className="text-sm text-gray-500 w-full">
                                <strong>Container number: </strong>{props.containerNumberInfo}
                                </p>                              
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 w-full flex flex-row-reverse sm:px-6">
                        <button
                            type="button"
                            style={{ borderWidth: '2px', borderStyles: 'solid', borderColor: 'black', cursor: 'pointer', }}
                            className="amazon-button inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                            onClick={() => handleDelete()}
                            id='modal-button'
                        >
                            Delete
                        </button>
                        <button
                            type="button"
                            style={{ cursor: 'pointer', }}
                            className="amazon-button-2 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm"
                            onClick={() => props.setOpen(false)}
                            id='modal-button'
                        >
                            Close
                        </button>
                        </div>
                    </Dialog.Panel>
                    </Transition.Child>
                </div>
                </div>
            </Dialog>
            </Transition.Root>
    )
}

export default DeleteModal;